/**
 * Shopify play kit products have a variety of asset kinds which we unfortunately,
 * are only able to identify by index. These helpers facilitate accessing assets by kind.
 */
// Maps the human-readable asset type to the index it is stored in on the Shopify Product
// media array for Play Kit products (The Looker Play Kit, The Charmer Play Kit, etc.)
import { TypeAsset, TypeProduct } from '@/lib/api/productCatalog/types';
import { ShopifyProductType } from '@/lib/shopify';

export enum KIT_ASSET_INDICES {
  OPEN_BOX = 1,
  CLOSED_BOX = 2,
  LIFESTYLE = 3,
  SPLASH_BOX = 4,
  NEW_BOX_WHITE_BG = 5,
  NEW_BOX_GRAY_BG = 6,
  NEW_LIFESTYLE_START = 7,
  NEW_LIFESTYLE_END = 10,
}

export function getAssetByKind(assets: TypeAsset[] | undefined, index: number) {
  if (!assets) return null;

  return assets.find((asset) => asset.sort_order === index);
}

export function getAssetForProduct(product: TypeProduct) {
  const featuredAsset = product.assets?.[0];

  if (product.product_type === ShopifyProductType.PLAY_KITS) {
    const playKitflatlayAsset = getAssetByKind(
      product.assets,
      KIT_ASSET_INDICES.NEW_BOX_GRAY_BG,
    );

    return playKitflatlayAsset || featuredAsset;
  }

  return featuredAsset;
}
